export default "__VITE_PUBLIC_ASSET__9d9c6470__"